<template>
  <v-container>
    <v-form @submit.prevent="submitNewPassword" class="form">
      <v-text-field v-model="password" :label="$t('settings.new_password_label')" type="password" :rules="[rules.password]" required></v-text-field>
      <v-text-field v-model="confirmPassword" :label="$t('settings.confirm_new_password_label')" type="password" :rules="[() => password === confirmPassword || t('rules.password_match')]"></v-text-field>

      <v-btn type="submit" color="primary">{{ t('login.password_set') }}</v-btn>
    </v-form>
  </v-container>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import apiClient from '/api.js';
import { useI18n } from 'vue-i18n';
import {useSnackbarStore} from '@/stores/snackbarStore'

const snackbar = useSnackbarStore()
const { t } = useI18n();

const password = ref('');
const confirmPassword = ref('');

const router = useRouter();
const route = useRoute();
const uid = route.params.uid;
const token = route.params.token;

const rules = {
  password: value => !value || value.length >= 8 || t('rules.password_min'),
};

const submitNewPassword = () => {
  const url = `password_reset_confirm/${uid}/${token}/`;
  apiClient.post(url, { password: password.value })
    .then(() => {
      snackbar.success(t('messages.password_reset'));
      // Přesměrujte uživatele na přihlašovací stránku nebo zobrazte potvrzovací stránku
      router.push('/login');
    })
    .catch(error => {
      if (error.response && error.response.data && error.response.data.error) {
        // Zobrazení chybové zprávy ze serveru
        snackbar.error(`${t('errors.request_failed')}: ${error.response.data.error}`);
      }
    });
};



</script>


<style scoped>
.form {
  max-width: 500px;
  padding-top: 40px;
  margin: 0px auto
}
</style>
